var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            rules: _vm.rules,
            "label-col": { span: 4 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("基本信息")]),
          _c(
            "a-form-item",
            { attrs: { label: "活码名称" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["liveCodeName", _vm.rules.liveCodeName],
                    expression: "['liveCodeName', rules.liveCodeName]",
                  },
                ],
                attrs: { maxLength: 30, placeholder: "请输入活码名称" },
              }),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "有效期", required: true } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { "default-value": 1 },
                          model: {
                            value: _vm.dateCheck,
                            callback: function ($$v) {
                              _vm.dateCheck = $$v
                            },
                            expression: "dateCheck",
                          },
                        },
                        [
                          _c(
                            "a-radio",
                            { staticClass: "radio_css", attrs: { value: 0 } },
                            [_vm._v(" 永久 ")]
                          ),
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v(" 自定义 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c("a-col", { attrs: { span: 7 } }),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _vm.dateCheck === 1
                    ? _c(
                        "a-form-item",
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "effectiveDate",
                                  { initialValue: _vm.systemTime },
                                ],
                                expression:
                                  "['effectiveDate', {  initialValue:systemTime}]",
                              },
                            ],
                            attrs: {
                              "disabled-date": _vm.disabledDate,
                              "disabled-time": _vm.disabledDateTime,
                            },
                            on: { change: _vm.onChange },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "活码类型", required: true } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          staticClass: "fix",
                          attrs: { name: "radioGroup2" },
                          model: {
                            value: _vm.liveCodeType,
                            callback: function ($$v) {
                              _vm.liveCodeType = $$v
                            },
                            expression: "liveCodeType",
                          },
                        },
                        [
                          _c(
                            "a-radio",
                            {
                              staticClass: "radio_second",
                              attrs: { value: 1 },
                            },
                            [_vm._v(" 单人活码 ")]
                          ),
                          _c(
                            "a-radio",
                            {
                              staticClass: "radio_second",
                              attrs: { value: 2 },
                            },
                            [_vm._v(" 多人活码 ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "r",
                              staticStyle: { cursor: "pointer" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "r",
                                  style: {
                                    clear: "both",
                                    whiteSpace: "nowrap",
                                  },
                                },
                                [
                                  _c(
                                    "a-popover",
                                    { attrs: { placement: "bottomLeft" } },
                                    [
                                      _c(
                                        "template",
                                        {
                                          staticStyle: { padding: "0" },
                                          slot: "content",
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "1、多人活码：多个员工共用一个活码，客户添加好友时随机分配；"
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "2、单人活码：1个员工生成1个活码（选择多个员工时，批量生产单个多人活码）"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/img/fill.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-row", { attrs: { gutter: 24 } }, [
            _c("div", { staticClass: "ant-row ant-form-item" }, [
              _c(
                "div",
                { staticClass: "ant-col ant-col-4 ant-form-item-label" },
                [
                  _c("label", { staticClass: "ant-form-item-required" }, [
                    _vm._v("选择员工"),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "ant-col ant-col-12 ant-form-item-control-wrapper",
                },
                [
                  _c("userPickerWithNoParents", {
                    ref: "userPickerWithNoParents",
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活码标签",
                        "label-col": { span: 6 },
                        "wrapper-col": { span: 18 },
                      },
                    },
                    [
                      _c("tagPicker", {
                        model: {
                          value: _vm.tagId,
                          callback: function ($$v) {
                            _vm.tagId = $$v
                          },
                          expression: "tagId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              false
                ? _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-button",
                        { attrs: { type: "link" }, on: { click: _vm.addTag } },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "link" },
                          on: { click: _vm.refreshTag },
                        },
                        [_vm._v("刷新")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("a-row", { attrs: { gutter: 24 } }, [
            _c("div", { staticClass: "form_title" }, [_vm._v("活码欢迎语")]),
            _c(
              "div",
              { staticClass: "text_editer" },
              [
                _c(
                  "div",
                  [
                    _c("span", [_vm._v("添加变量：")]),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.insert("@「客户昵称」", 0)
                          },
                        },
                      },
                      [_vm._v("客户昵称")]
                    ),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.insert("@「员工名称」", 0)
                          },
                        },
                      },
                      [_vm._v("员工名称")]
                    ),
                  ],
                  1
                ),
                _c("chatInput", {
                  ref: "chatInput",
                  staticClass: "chatInput",
                  model: {
                    value: _vm.liveCodeContent,
                    callback: function ($$v) {
                      _vm.liveCodeContent = $$v
                    },
                    expression: "liveCodeContent",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "form_title" }, [
            _vm._v("添加照片/网页/小程序"),
          ]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "消息类型",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { "button-style": "solid" },
                          model: {
                            value: _vm.msgType,
                            callback: function ($$v) {
                              _vm.msgType = $$v
                            },
                            expression: "msgType",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "image" } }, [
                            _vm._v("图片"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "link" } }, [
                            _vm._v("图文链接"),
                          ]),
                          _c(
                            "a-radio-button",
                            { attrs: { value: "miniprogram" } },
                            [_vm._v("小程序")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { color: "#ff0000", "line-height": "30px" } },
            [_vm._v("（仅可选择一类消息类型，若切换则已填写内容会被清空）")]
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _vm.msgType === "image"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "图片设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["attachmentUrls"],
                              expression: "['attachmentUrls']",
                            },
                          ],
                          attrs: {
                            num: 9,
                            accept: "image/*",
                            url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：png,jpg,gif，建议大小2M，最多9张")]
                    ),
                  ]
                : _vm._e(),
              _vm.msgType === "miniprogram"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序标题",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "miniprogramTitle",
                                _vm.rules.miniprogramTitle,
                              ],
                              expression:
                                "['miniprogramTitle',rules.miniprogramTitle]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序appid",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "miniprogramAppid",
                                _vm.rules.miniprogramAppid,
                              ],
                              expression:
                                "['miniprogramAppid',rules.miniprogramAppid]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序页面地址",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "miniprogramPage",
                                _vm.rules.miniprogramPage,
                              ],
                              expression:
                                "['miniprogramPage',rules.miniprogramPage]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "小程序封面图",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["miniprogramImgUrl"],
                              expression: "['miniprogramImgUrl']",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: "image/*",
                            url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：png,jpg，封面图建议尺寸为520*416")]
                    ),
                  ]
                : _vm._e(),
              _vm.msgType === "link"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网页标题",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["linkTitle", _vm.rules.linkTitle],
                              expression: "['linkTitle',rules.linkTitle]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网页链接",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["linkUrl", _vm.rules.linkUrl],
                              expression: "['linkUrl',rules.linkUrl]",
                            },
                          ],
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网页封面图",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["linkImgUrl"],
                              expression: "['linkImgUrl']",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: "image/*",
                            url: _vm.api.temp.WX_UPLOAD_IMG_PATH,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：png,jpg，建议大小2M")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "活码标签",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 600,
          },
          on: { cancel: _vm.closeEdit },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: 0 },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }